import { Injectable, ErrorHandler } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { LogService } from '@bioconnect-ui/log-service';
import { UserProfile } from '@bioconnect-ui/user-service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {

  constructor(
    private logService: LogService,    
    public auth: AuthService
    ) { }
  handleError(error: any): void {
    this.auth.user$.subscribe(profile => {
      const userProfile = <UserProfile>profile;
      this.logService.setUserId(userProfile?.email || 'unknown');
      console.error(error);
      this.logService.logException(error);
    });    
  }
}